import {
  B2BCoursePackProto,
  B2BProductOfferingProto,
} from "@noom/noom-contracts/noom_contracts/backend/enrollment/b2b/enrollment_offerings";
import { CurriculumNameProto_CurriculumName } from "@noom/noom-contracts/noom_contracts/events/app/curriculum/shared";

import { ProgramOffering } from "@/constants";

import { captureMessage } from "../sentry";

const coursePackToProgramOffering = (
  coursePack: B2BCoursePackProto,
): ProgramOffering | null => {
  switch (coursePack.value) {
    case "MED":
      return "MED";
    case "NOOM_MED_POWERED_BY_ACCOLADE":
      return "NMPBA";
    case "DIABETES_SUPPORT":
      return "DIABETES_LIFESTYLE";
    default:
      return null;
  }
};

const curriculumNameToProgramOffering = (
  curriculumName: CurriculumNameProto_CurriculumName,
): ProgramOffering | null => {
  switch (curriculumName) {
    case "DIABETES_PREVENTION":
      return "DPP";
    case "HEALTHY_WEIGHT":
      return "WEIGHT";
    case "HEALTHY_MIND":
      return "MOOD";
    default:
      return null;
  }
};

export const productOfferingToProgramOfferings = (
  productOffering: B2BProductOfferingProto,
): Set<ProgramOffering> => {
  const curriculumPo = curriculumNameToProgramOffering(productOffering.program);
  if (!curriculumPo) {
    captureMessage(
      `No program offering found for curriculum: ${productOffering.program}`,
    );
    return new Set();
  }
  const coursePackPos: ProgramOffering[] = productOffering.coursePacks
    .map(coursePackToProgramOffering)
    .filter((p) => !!p) as ProgramOffering[];
  return new Set([curriculumPo, ...coursePackPos]);
};
